var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailCustomerCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27161_148532)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C4.03738 18 0 13.9626 0 9C0 4.03738 4.03738 0 9 0C13.9626 0 18 4.03738 18 9C18 13.9626 13.9626 18 9 18ZM13.6673 12.1616C13.7782 12.1616 13.8685 12.0714 13.8685 11.9604V6.31016L9.28944 9.94644C9.20471 10.0138 9.1023 10.0474 8.99996 10.0474C8.89762 10.0474 8.79525 10.0137 8.71049 9.94644L4.13142 6.31016V11.9604C4.13142 12.0714 4.22174 12.1616 4.33269 12.1616H13.6673ZM12.9656 5.83836L9 8.98748L5.03441 5.83836H12.9656ZM14.7996 6.03963V11.9604C14.7996 12.5848 14.2916 13.0927 13.6673 13.0927H4.33269C3.70832 13.0927 3.20041 12.5848 3.20041 11.9604V6.03963C3.20041 5.41529 3.70835 4.90736 4.33269 4.90736H13.6673C14.2916 4.90732 14.7996 5.41529 14.7996 6.03963Z",
    fill: "#E95F56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27161_148532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCustomerCard);
export default __webpack_public_path__ + "static/media/emailCustomerCard.9bd4b2e908f65c6b0a30ee8391d0385d.svg";
export { ForwardRef as ReactComponent };